/************ ************/
/***** Layout Helper *****/
/************ ************/

export const MODAL_FREEWAVE_ID = "modal-freewave";
export const MIN_SCREEN_WIDTH = 1350;
